export default {
  AWS_LAMBDA_GETSIGNEDURL_ENDPOINT: process.env.VUE_APP_PRESIGNED
};
